<template>
  <a-dropdown v-if="currentUser && currentUser.nickName"
              placement="bottomRight">
    <span class="ant-pro-account-avatar">
      <a-avatar :size="32"
                :src="headUrl"
                class="antd-pro-global-header-index-avatar s-h-s-w-i" />
      <span class="nickname"
            :style="{ color: colorValue }">{{ currentUser.nickName }}</span>
    </span>
    <template v-slot:overlay>
      <a-menu class="ant-pro-drop-down menu"
              :selected-keys="[]">
        <a-menu-item v-if="menu"
                     key="settings"
                     @click="handleToSettings">
          <a-icon type="setting" />
          {{ $t('menu.account.settings') }}
        </a-menu-item>
        <a-menu-divider v-if="menu" />
        <a-menu-item key="logout"
                     @click="handleLogout">
          <a-icon type="logout" />
          {{ $t('menu.account.logout') }}
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
  <span v-else>
    <a-spin size="small"
            :style="{ marginLeft: 8, marginRight: 8 }" />
  </span>
</template>

<script>
import { Modal } from 'ant-design-vue'

export default {
  name: 'AvatarDropdown',
  props: {
    colorValue: {
      type: String,
      default: '#001529'
    },
    currentUser: {
      type: Object,
      default: () => null
    },
    menu: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    headUrl () {
      return (
        this.$store.state.user.headUrl ||
        'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png'
      )
    }
  },
  watch: {},
  methods: {
    handleToCenter () {
      this.$router.push({ path: '/account/center' })
    },
    handleToSettings () {
      this.$router.push({ path: '/account/settings' })
    },
    handleLogout (e) {
      Modal.confirm({
        title: this.$t('layouts.usermenu.dialog.title'),
        content: this.$t('layouts.usermenu.dialog.content'),
        onOk: () => {
          return this.$store.dispatch('Logout').then(() => {
            window.location.href = window.location.origin
          })
        },
        onCancel () { }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-pro-drop-down {
  /deep/ .action {
    margin-right: 8px;
  }

  /deep/ .ant-dropdown-menu-item {
    min-width: 160px;
  }
}

.s-h-s-w-i {
  right: 2px;
  bottom: 3px;
}

.nickname {
  font-size: 22px;
  font-weight: bolder;
  font-family: MicrosoftYaHeiSemibold;
  cursor: pointer;
}
</style>
